
      export interface IntrospectionResultData {
        __schema: {
          types: {
            kind: string;
            name: string;
            possibleTypes: {
              name: string;
            }[];
          }[];
        };
      }
      const result: IntrospectionResultData = {
  "__schema": {
    "types": [
      {
        "kind": "UNION",
        "name": "CalendarEvent",
        "possibleTypes": [
          {
            "name": "Lesson"
          },
          {
            "name": "TimeOff"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "CreatePurchaseLeadResult",
        "possibleTypes": [
          {
            "name": "CreatePurchaseLeadSuccess"
          },
          {
            "name": "CreatePurchaseLeadFailure"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "Customer",
        "possibleTypes": [
          {
            "name": "Learner"
          },
          {
            "name": "Instructor"
          },
          {
            "name": "Lead"
          }
        ]
      },
      {
        "kind": "INTERFACE",
        "name": "Person",
        "possibleTypes": [
          {
            "name": "Instructor"
          },
          {
            "name": "Lead"
          },
          {
            "name": "Learner"
          }
        ]
      }
    ]
  }
};
      export default result;
    